import { useState, useEffect } from 'react';
import { Box } from '@material-ui/core';
import { useInView } from 'react-intersection-observer';
import PerfectScrollbar from 'react-perfect-scrollbar';

import { ICannedReply } from '../../../interfaces';
import { useConnect } from '../../../context/connect';
import { Item } from './Item';

import { useStyles } from './style';

export const List = ({
  setDataForUpdate,
  setMode,
}: {
  setDataForUpdate: React.Dispatch<
    React.SetStateAction<ICannedReply | undefined>
  >;
  setMode: React.Dispatch<React.SetStateAction<null | 'create' | 'update'>>;
}) => {
  const classes = useStyles();
  const { cannedResponses } = useConnect();
  const [ref, inViewEnd] = useInView();
  const [loading, setLoading] = useState<boolean>(false);
  const [offset, setOffset] = useState<number>(
    Math.min(cannedResponses.length, 20)
  );
  const [responses, setResponses] = useState<ICannedReply[]>([]);

  useEffect(() => {
    if (cannedResponses) {
      setResponses(cannedResponses.slice(0, 20));
    }
  }, [cannedResponses]);

  useEffect(() => {
    if (inViewEnd) {
      setLoading(true);
    }
  }, [inViewEnd]);

  useEffect(() => {
    if (loading && responses.length === offset) {
      setResponses((prev) => {
        const start = offset;
        const end = Math.min(cannedResponses.length, offset + 20);

        return [...prev, ...cannedResponses.slice(start, end)];
      });
    }
  }, [loading, offset, responses.length, cannedResponses]);

  useEffect(() => {
    if (responses.length !== offset) {
      setOffset(responses.length);
      setLoading(false);
    }
  }, [responses.length, offset]);

  return (
    <PerfectScrollbar style={{ height: '428.5px' }}>
      <Box px={2} position={'relative'}>
        {responses.map((i) => (
          <Item
            key={i.id}
            item={i}
            setDataForUpdate={setDataForUpdate}
            setMode={setMode}
          />
        ))}
        {responses.length < cannedResponses.length && !loading && (
          <div className={classes.in_view} ref={ref}></div>
        )}
      </Box>
    </PerfectScrollbar>
  );
};
